import { seriesSvgBar, seriesSvgMulti } from '@d3fc/d3fc-series';

import { BaseType, select, Selection } from 'd3-selection';
import {
    VolumeCapsuleChartBar,
    VolumeCapsuleData,
} from 'widgets/liquiditySummary/volumeCapsule/components/volumeCapsuleData';
import { SeriesPoint } from 'utils/stackedSeries';

export interface VolumeCapsuleSeriesPoint
    extends SeriesPoint<VolumeCapsuleChartBar> {
    key: string;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export type VolumeCapsuleSelection = Selection<
    BaseType,
    VolumeCapsuleSeriesPoint,
    any,
    any
>;

export const volumeCapsuleChartSeries = (chartData: VolumeCapsuleData) => {
    const barSeries = (bar: 'hist' | 'today') =>
        seriesSvgBar()
            .orient('horizontal')
            .align('center')
            .crossValue((d: VolumeCapsuleSeriesPoint) =>
                d.data.bar === bar ? d.data.row : undefined
            )
            .mainValue((d: VolumeCapsuleSeriesPoint) => d[1])
            .baseValue((d: VolumeCapsuleSeriesPoint) => d[0])
            .bandwidth(() => (bar === 'hist' ? 40 : 15))

            .decorate((selection: VolumeCapsuleSelection) => {
                selection.enter().each((data, index, nodes) => {
                    select(nodes[index])
                        .classed(data.key, true)
                        .classed(data.data.bar, true);
                });

                selection
                    .enter()
                    .filter((d) => d.data.bar === 'today' && d.key === 'close')
                    .append('rect')
                    .attr('x', () => {
                        return -1;
                    })
                    .attr('y', -30)
                    .attr('width', 1)
                    .attr('height', 21)
                    .attr('class', 'adv-line');
            });

    const stackedBarSeries = (bar: 'hist' | 'today') =>
        seriesSvgMulti()
            .mapping((data: number[], index: number) => data[index])
            .series(chartData.stackedSeriesData.map(() => barSeries(bar)));

    return seriesSvgMulti().series([
        stackedBarSeries('hist'),
        stackedBarSeries('today'),
    ]);
};
